import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-checkandfacilities',
  templateUrl: './checkandfacilities.component.html',
  styleUrls: ['./checkandfacilities.component.css']
})
export class CheckandfacilitiesComponent implements OnInit {
  typeclicked:any;
  value;
  ref: MatDialogRef<any>;
  langconfig;
  flightNo;
  Date
  environment = environment
  dialogopened:boolean = false;
  SearchLoader:boolean = false;
  showdialogbox:boolean = false;
  userStop$: Subject<boolean> = new Subject<boolean>();
  apiTrigger$: Subject<boolean> = new Subject<any>();
  dataarray;
  nodatamessage;
  flightdata
  datajson = require('../../Jsons/'+environment.project+'data.json')
  shoplist=this.datajson['shoplist']
  servicelist=this.datajson['servicelist'];
  servicel=this.datajson['servicel'];
  facilitiesl= this.datajson['facilitiesl'];
  boardinggate= this.datajson['boardinggate'];
  Terminaltext = this.datajson['Terminal']
  selectedIndex: number = 0;
  showaccordian:boolean = false;
  boadringgate;
  deptime;
  showerror:boolean= false;
  stepslist = [
    'Tap the "Share" icon located in Browser.',
    'Select "Add to Home Screen" from the options.',
    'Tap "Add" or "Ok" to complete the process.',
    'Access Smart Boarding from home screen.',
    'Enable notifications.',
  ]
  @Output() backclickedevent: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild("notificationComponent", { read: TemplateRef, static: false }) notificationComponent: TemplateRef<any>;
  ref1: MatDialogRef<any>;
  @ViewChild("nopermission", { read: TemplateRef, static: false }) nopermission: TemplateRef<any>;
  @ViewChild("iOSpopup", { read: TemplateRef, static: false }) iOSpopup: TemplateRef<any>;
  constructor(private devicedetails: DeviceDetectorService, private datepipe:DatePipe, private router: Router, private route: ActivatedRoute,  private apiService: ApiService,public dialog: MatDialog, private cookieService : CookieService, private apiservice:ApiService) {
    this.route.queryParams.subscribe(params => {
      this.typeclicked = params['service'];
    });
    if(this.typeclicked == 'checkpostlist'){
      this.flightNo = sessionStorage.getItem('searchedFlight')
      if(this.flightNo){
        const searchedflightdata = this.apiService.getflightshareddata();
        if(searchedflightdata){
          this.searchforflightdetails(searchedflightdata.data[0]);
        }else{
          this.searchforflightdetails(this.flightNo);
        }
      }
    }
   }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkOrientation();
  }

  ngOnInit(): void {
    this.checkOrientation();
    this.apiService.language.subscribe((res)=>{
      const langcode = res.code
      this.langconfig = langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
    })
  }

  notificationicon() {
    try {
        this.value = localStorage.getItem('notification');
        if (typeof Notification !== 'undefined') {
            if ((Notification.permission === 'denied' && localStorage.getItem('subvalue')) || 
                (Notification.permission === 'default' && localStorage.getItem('subvalue'))) {
                this.apiservice.unsubvalue();
            }
            return this.value === 'true' && Notification.permission === 'granted'
                ? '/assets/images/svg/notificationiconADR.svg'
                : '/assets/images/svg/nonotificationADR.svg';
        } else {
            console.warn('Notification API is not supported in this environment.');
            return '/assets/images/svg/nonotificationADR.svg';
        }
    } catch (error) {
        console.log(error);
    }
  }

  
  notificationiconclick(){
    if(this.value == 'true'){
      if('Notification' in window){ 
        if(Notification.permission == 'granted'){
          this.savesubscriptoin();
        }else if(Notification.permission == 'denied'){
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.nopermission)
        }else if(Notification.permission == 'default'){
          this.apiservice.setnotification('false')
          this.dialogopened = true;
          this.ref = this.dialog.open(this.notificationComponent)
        }
      }
    }else if(!localStorage.getItem('subvalue')){
      if(!this.dialogopened){
        if('Notification' in window){
          if(Notification.permission == 'granted' || Notification.permission == 'default'){
            this.dialogopened = true;
            this.ref = this.dialog.open(this.notificationComponent)
          }else if(Notification.permission == 'denied'){
            this.dialogopened = true;
            this.ref1 = this.dialog.open(this.nopermission)
          }
        }else{
          console.log('no notification show to click on the share');
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.iOSpopup)
        }
      }
    }else if(localStorage.getItem('subvalue') && Notification.permission == 'default'){
      Notification.requestPermission().then((res)=>{
        if(res == 'granted'){
          this.apiservice.setnotification('false')
          this.savesubscriptoin();
        }else if(res == 'default'){
          Notification.requestPermission().then(res=>{
            if(res == 'granted'){
              this.apiservice.setnotification('false');
              this.savesubscriptoin();
            }
          })
        }
      })
    }else if(Notification.permission == 'granted'){
      this.savesubscriptoin();
    }else if(Notification.permission == 'denied'){
      if(!this.dialogopened){
        if(this.devicedetails.os != 'iOS'){ // checking notification in the window
          if(Notification.permission == 'denied'){ // condition to handle to show if notifications are denied
            this.dialogopened = true;
            this.ref1 = this.dialog.open(this.nopermission)
          }
        }else{
          this.dialogopened = true;
          this.ref1 = this.dialog.open(this.iOSpopup)
        }
      }
    }
  }

  closedialog2(){
    this.dialogopened = false;
    this.ref1.close();
  }


  closedialog1(value){
    if(!value){
      this.dialogopened = false;
      this.ref.close();
    }else{
      this.dialogopened = false;
      const subvalue = localStorage.getItem('subvalue');
      const sub = JSON.parse(subvalue);
      if(!sub){
        this.getSubscription()
      }else if(sub && Notification.permission == 'granted'){
        this.savesubscriptoin();
      }else if(sub && Notification.permission == 'default'){
        Notification.requestPermission().then((res)=>{
          if(res == 'granted'){
            this.savesubscriptoin();
          }
        })
      }
      this.ref.close();
    }
  }

  getSubscription(){
    this.apiservice.getsubscriptionvalue()
  }

  savesubscriptoin(){
    this.apiservice.callsavesubscription();
  }


  backclicked(){
    // this.backclickedevent.emit();
    sessionStorage.setItem('bahome', 'true');
    this.router.navigate(['/'])

  }

  selectedindex(index: number) {
    this.selectedIndex = index; // set the selected index on click
  }

  closeaccordian(i){
    i['collapse'] = !i['collapse']
  }

  changeinputvalue(){
    this.showerror = false;
    this.callautosuggestapi();
  }


  callautosuggestapi(){
    if(this.flightNo.length >0){
      const flightdata = this.flightNo.toUpperCase()
      const params = {
        fdata: flightdata
      }
      // if(s){
        params['search_by'] = 'flight',
        params['airlines'] = ['BA']
      // }
      this.SearchLoader = true;
      this.showdialogbox = false;
      this.apiTrigger$
      .pipe(
        switchMap(() => this.apiservice.Autosearchapi(params)),
        takeUntil(this.userStop$)
      )
      .subscribe(
        response => {
          this.userStop$.next(true);
          this.showdialogbox = true;
          this.dataarray = [];
          this.nodatamessage = response.data.length > 0 ? false : true;
          const cutoffdata = response.data.slice(0, 10);
          this.dataarray = cutoffdata;
          this.SearchLoader = false;
        },
        error => {
          this.nodatamessage = true;
          this.SearchLoader = false;
        },
      );
      this.apiTrigger$.next(flightdata);
    }
  }
  selectedflightdata;
  opengate(flightsdata){
    this.showdialogbox = false;
    this.apiService.setsearchedflightdta(flightsdata)
    this.selectedflightdata = flightsdata;
    this.flightNo = flightsdata.flight;
    // this.searchforflightdetails(flightsdata)
  }

  searchforflightdetails(flight?){
    if(flight && flight.flight){
      this.flightNo = flight.flight;
    }
    this.flightNo = this.flightNo.toUpperCase();
    const params = {
      fdata: this.flightNo,
    }
    if(flight && flight.flight_pk){
      params['search_by'] = 'flight',
      params['airlines'] = flight.flight_pk
    }
    this.apiService.clicksearchapi(params).subscribe((res)=>{
      this.showdialogbox = false;
      sessionStorage.setItem('searchedFlight', this.flightNo);
      if(flight && flight.flight_pk){
        res.data[0]['flight_pk'] = flight.flight_pk;
      }
      this.apiService.setsearchedflightdta(res);
      const respo = res.data[0]
      this.selectedflightdata = respo;
      this.boadringgate = respo.gate;
      this.deptime = respo.departure;
    },(error)=>{
      this.showerror=true;
      this.boadringgate = null;
      this.deptime = null;
    })
  }

  closedialogss(s?){
    if(s){
      this.showdialogbox = this.showdialogbox
    }else{
      if(this.showdialogbox){
        this.showdialogbox = false;
      }
    }

  }

  setflightdate(date){
    const today = this.datepipe.transform(new Date);
    const tomorrowDate = new Date();
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);
    const tommorow = this.datepipe.transform(tomorrowDate);
    const value = this.datepipe.transform(date);
    if(today == value){
      return 'Today';
    }else if(tommorow == value){
      return 'Tomorrow'
    }else{
      return this.datepipe.transform(date);
    }
  }
  redtext:boolean = false;
  checkvalue(flight){
    if(flight){
      const std = this.datepipe.transform(flight.std, "HH:mm");
      const etd = this.datepipe.transform(flight.etd, "HH:mm");
      if(flight.etd){
        this.redtext = std == etd ? false : true;
        return std == etd ? false : true;
      }else{
        return false;
      }
    }
  }

  isPortrait:boolean = false;
  checkOrientation(): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false
    // console.log(this.isPortrait);
  }

}
